import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
    state: {
        userList: [],
    },
    mutations: {
        getUserList(state, userList) {
            Vue.set(state, 'userList', userList)
        }
    },
    actions: {
        async getUserList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSystemUserList`, data)
                    if (!result.data.errorCode || result.data.errorCode === 0) {
                        context.commit("getUserList", result.data);
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async deleteUserList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/delSystemUser`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async detailUserList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSystemUserDetail`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async createSystemUser(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/createSystemUser`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async updateSystemUser(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/updateSystemUser`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
    },
    getters: {
    }
}

export default moduleStore;